/**
* Copyright Aquera Inc 2025
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import { css } from 'lit';

/**
 * InlinesidebarItem CSS — Enterprise (`--nile-*`) primary, NxtGen (`--ng-*`) fallback.
 */
export const styles = css`
:host {
  display: block;
  font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
  font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
  color: var(--nile-colors-dark-900, var(--ng-colors-text-primary-900));
  cursor: pointer;
  user-select: none;
}

.item {
  padding: var(--nile-spacing-lg, var(--ng-spacing-lg)) var(--nile-spacing-md, var(--ng-spacing-md));
  border-radius: var(--nile-radius-sm, var(--ng-radius-xs));
  transition: background 0.2s, color 0.2s;
}

:host(:not([disabled])) .item:hover {
  background: var(--nile-colors-neutral-400, var(--ng-colors-bg-tertiary));
}

:host([active]) .item {
  background: var(--nile-colors-primary-100, var(--ng-colors-bg-brand-secondary));
  font-weight: var(--nile-font-weight-medium, var(--ng-font-weight-medium));
  color: var(--nile-colors-primary-700, var(--ng-colors-text-brand-secondary-700));
}
:host([active]) .item--rich {
  border-right: 2px solid var(--nile-colors-primary-600, var(--ng-colors-border-brand));
}

:host([active]) .item:hover {
  background: var(--nile-colors-primary-100, var(--ng-colors-bg-brand-secondary));
}

:host([disabled]) {
  color: var(--nile-colors-neutral-500, var(--ng-colors-text-disabled));
  cursor: not-allowed;
}

:host([disabled]) .item {
  pointer-events: none;
}
a {
    color: inherit;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 100%;
  }

  a:visited,
  a:hover,
  a:active,
  a:focus {
    color: inherit;
    text-decoration: none;
  }
`;
